const vP18360 = require("./306.js");
function f2189(ctx, canvas, p18363) {
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  if (!canvas.style) {
    canvas.style = {};
  }
  canvas.height = p18363;
  canvas.width = p18363;
  canvas.style.height = p18363 + "px";
  canvas.style.width = p18363 + "px";
}
function f2190() {
  try {
    return document.createElement("canvas");
  } catch (e179) {
    throw new Error("You need to specify a canvas element");
  }
}
exports.render = function (p18364, p18365, p18366) {
  let vP18366 = p18366;
  let vP18365 = p18365;
  if (typeof vP18366 == "undefined" && (!p18365 || !p18365.getContext)) {
    vP18366 = p18365;
    p18365 = undefined;
  }
  if (!p18365) {
    vP18365 = f2190();
  }
  vP18366 = vP18360.getOptions(vP18366);
  const v14097 = vP18360.getImageWidth(p18364.modules.size, vP18366);
  const v14098 = vP18365.getContext("2d");
  const v14099 = v14098.createImageData(v14097, v14097);
  vP18360.qrToImageData(v14099.data, p18364, vP18366);
  f2189(v14098, vP18365, v14097);
  v14098.putImageData(v14099, 0, 0);
  return vP18365;
};
exports.renderToDataURL = function (p18367, p18368, p18369) {
  let vP18369 = p18369;
  if (typeof vP18369 == "undefined" && (!p18368 || !p18368.getContext)) {
    vP18369 = p18368;
    p18368 = undefined;
  }
  if (!vP18369) {
    vP18369 = {};
  }
  const v14100 = exports.render(p18367, p18368, vP18369);
  const v14101 = vP18369.type || "image/png";
  const v14102 = vP18369.rendererOpts || {};
  return v14100.toDataURL(v14101, v14102.quality);
};